import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Account`;



const ApiAccount = {
  getAllAccount: (params) => {
    const url = `${baseServiceUrl}/getAllAccount`;
    return ServiceApi.get(url, { params });
  },
  getAllAccountSaamaneh: (params) => {
    const url = `${baseServiceUrl}/getAllAccountSaamaneh`;
    return ServiceApi.get(url, { params });
  },
  getAccountById: (id) => {
    const url = `${baseServiceUrl}/getAccountById?id=${id}`;
    return ServiceApi.get(url);
  },
  getAccountByAgencyId: (params) => {
    const url = `${baseServiceUrl}/getAccountByAgencyId?agencyId=` + params;
    return ServiceApi.get(url, { params });
  },
  createAccount: (params) => {
    const url = `${baseServiceUrl}/createAccount`;
    return ServiceApi.post(url, params);
  },
  updateAccount: (params) => {
    const url = `${baseServiceUrl}/updateAccount`;
    return ServiceApi.put(url, params);
  },
  changeAccountStatus: (params) => {
    const url = `${baseServiceUrl}/changeAccountStatus`;
    return ServiceApi.put(url, params);
  },
  createAccountCard: (params) => {
    const url = `${baseServiceUrl}/createAccountCard`;
    return ServiceApi.post(url, params);
  },
  updateAccountCard: (params) => {
    const url = `${baseServiceUrl}/updateAccountCard`;
    return ServiceApi.put(url, params);
  },
  changeAccountCardStatus: (params) => {
    const url = `${baseServiceUrl}/changeAccountCardStatus`;
    return ServiceApi.put(url, params);
  },
  getAllAccountForUserId: (params) => {
    const url = `${baseServiceUrl}/getAllAccountForUserId`;

    return ServiceApi.get(url, params);
  },
};

export default ApiAccount;


